import { motion } from "framer-motion";
import { BRAND } from "@/data/content";
import { useLang } from "@/i18n/LanguageContext";

export const Stats = () => {
    const { t } = useLang();
    return (
        <section
            id="stats"
            data-testid="stats-section"
            className="relative py-14 sm:py-20 bg-black border-y border-white/5 overflow-hidden"
        >
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,90,0,0.08),transparent_60%)]" />
            <img
                src={BRAND.icon}
                alt=""
                aria-hidden="true"
                className="absolute -left-20 sm:-left-10 top-1/2 -translate-y-1/2 w-[280px] sm:w-[420px] opacity-[0.06] pointer-events-none select-none"
            />
            <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
                    {t.stats.items.map((s, i) => (
                        <motion.div
                            key={i}
                            data-testid={`stat-${i}`}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.1 }}
                            className="text-center group relative"
                        >
                            <div className="font-display text-5xl sm:text-6xl lg:text-7xl text-gradient-orange tracking-wider transition-transform group-hover:scale-110">
                                {s.value}
                            </div>
                            <div className="mt-3 text-sm sm:text-base text-neutral-400 uppercase tracking-widest">
                                {s.label}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
